import { suggestionStyles } from "@insite/content-library/Widgets/ProductList/ProductListSuggestion";
import { css } from "styled-components";

suggestionStyles.wrapper = {
    css: css`
        > span {
            font-size: 22px;
            color: #ef3742;
        }
        a > span {
            font-size: 22px;
            font-style: italic;
        }
    `,
};
